import Nullstack from 'nullstack';
export default function IconArrowRotaryLastLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-rotary-last-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 15a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
  }), "   ", Nullstack.element("path", {
    d: "M15 15v6"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 9.5l-6.5 -6.5"
  }), "   ", Nullstack.element("path", {
    d: "M11 3h-5v5"
  }), " ");
}